// extracted by mini-css-extract-plugin
export var chart = "styles-module--chart--1eaea";
export var wrapper = "styles-module--wrapper--bca1b";